<app-form-delegate
    [add]="false"
    [delegate]="selectedDelegate"
    [fromUser]="fromUser"
    [toUser]="toUser"
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)"
>
</app-form-delegate>

